import { createStore } from "vuex";
import createPersistedState from 'vuex-persistedstate';


import notes from './modules/notes';
import users from './modules/users';
import notifications from "./modules/notifications";
import proceedings from "./modules/proceedings";
import limits from './modules/limits';
import plans from './modules/plans';
import subscriptions from './modules/subscriptions';
import theme from './modules/theme';

export default createStore({
  modules: {
    notes,
    users,
    notifications,
    proceedings,
    limits,
    plans,
    subscriptions,
    theme
  },
  plugins: [createPersistedState()]
});
